import { render, staticRenderFns } from "./manager-index.vue?vue&type=template&id=28584f74&scoped=true"
import script from "./manager-index.vue?vue&type=script&lang=js"
export * from "./manager-index.vue?vue&type=script&lang=js"
import style0 from "./manager-index.vue?vue&type=style&index=0&id=28584f74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28584f74",
  null
  
)

export default component.exports